<template>
  <b-button
    class="timer-button"
    :class="{ transition, translate }"
    v-bind="props"
    @click="click"
  >
    <slot>Start</slot>
  </b-button>
</template>

<script>
export default {
  props: {
    manual: {
      type: Boolean,
      default: false,
    },
    props: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    transition: false,
    translate: false,
    timeoutInit: null,
    timeoutTranslate: null,
  }),
  methods: {
    click() {
      this.$emit("click");
      if (!this.manual) {
        this.resetTimer();
        this.startTimer();
      }
    },
    startTimer() {
      this.timeoutInit = setTimeout(() => {
        this.transition = true;
        setTimeout(() => {
          this.translate = true;
        }, 500);
      }, 500);
      this.timeoutTranslate = setTimeout(() => {
        this.transition = false;
        this.translate = false;
        this.$emit("timeout");
      }, 6000);
    },
    resetTimer() {
      clearTimeout(this.timeoutInit);
      clearTimeout(this.timeoutTranslate);
      this.transition = false;
      this.translate = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.timer-button {
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.1) 50%,
    transparent 50%
  );
  background-size: 200%;
  background-position: right;
}
.transition {
  transition: background-position 5s linear;
}
.translate {
  background-position: left;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/TimerButton.vue